/**
 * Device auth hook.
 *
 * Device JWT is obtained during provisioning and stored in localStorage
 * (Bearer token auth, not cookie — cross-site cookies blocked by modern
 * browsers). Token is long-lived (1 year). If missing, forces re-provisioning.
 */
import { useEffect } from 'react';
import { useKioskStore } from '@/store/kiosk-store';

export function useAuth(): void {
  const jwt = useKioskStore((s) => s.jwt);
  const isProvisioned = useKioskStore((s) => s.isProvisioned);
  const deprovision = useKioskStore((s) => s.deprovision);

  useEffect(() => {
    // If provisioned but no token (e.g. localStorage cleared), force re-provision
    if (isProvisioned && !jwt) {
      deprovision();
    }
  }, [jwt, isProvisioned, deprovision]);
}
